module.exports = __webpack_public_path__ + "img/dot-white.55f24946.svg";